import api from '../../../core/api/client';

const BASE = '/brand-standards';
const byId = (id) => `${BASE}/${encodeURIComponent(id)}`;

const toApiError = (error) => {
  if (error?.response) {
    const d = error.response.data;
    return {
      status: error.response.status,
      message: d?.detail || d?.message || d?.error || error.message || 'Request failed',
      data: d,
    };
  }
  return { status: 0, message: error?.message || 'Unexpected error', data: null };
};

const wrap = async (fn) => {
  try { return await fn(); }
  catch (error) { throw toApiError(error); }
};

export const brandStandardsService = {
  async list({ includeHistory = false } = {}) {
    return wrap(async () => {
      const params = includeHistory ? { include_history: true } : {};
      const response = await api.get(BASE, { params });
      return response.data;
    });
  },

  async create(data) {
    return wrap(async () => {
      const response = await api.post(BASE, data);
      return response.data;
    });
  },

  async getSection(section) {
    return wrap(async () => {
      const response = await api.get(`${BASE}/section/${encodeURIComponent(section)}`);
      return response.data;
    });
  },

  async get(standardId) {
    return wrap(async () => {
      const response = await api.get(byId(standardId));
      return response.data;
    });
  },

  async update(standardId, patch) {
    return wrap(async () => {
      const response = await api.patch(byId(standardId), patch);
      return response.data;
    });
  },

  async delete(standardId) {
    return wrap(async () => {
      const response = await api.delete(byId(standardId));
      return response.data;
    });
  },
};

export const KNOWN_SECTIONS = [
  'colors', 'typography', 'logos', 'voice',
  'poster_rules', 'spacing', 'iconography', 'imagery',
];
